import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Checkbox, Chip, Link, fade, Typography, Badge } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'redux/store';
import { FileUploader } from '@crema/core/FileUploader';
import { Box, InputLabel, TextField, Button, Divider } from '@material-ui/core';
import { useAuthUser } from '@crema/utility/AppHooks';
import csv from 'csvtojson';
import { saveSpaceCustomData, saveSpaceCustomDataField } from 'redux/actions/Home';
import { fetchError, showMessage } from 'redux/actions';
import { CustomDataType, CustomDataField, CustomData, FieldType, ShowcaseTag } from 'types/models/home/HomeApp';
import TableSidebar from './TableSidebar';
import Layout from '../layout';
import MpSdk from 'mp/MpSdk';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import AppDataGrid from '@crema/core/AppDataGrid/AppDataGrid';
import { ComponentCard } from '@crema';
import AppCard from '@crema/core/AppCard';
import { ShowcaseTagMap } from 'redux/reducers/Home';
import { handleTagClick, isUserAdmin } from 'modules/home/SpaceDetail/utils';
import { store } from 'App';
import Utils from 'mp/core/craEngine/Tools/Utils';
import Simulation from 'mp/core/craEngine/SubSystems/core/Simulation';
// import { Tab, Tabs } from '@mui/material';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabContext, TabPanel } from '@material-ui/lab';
import { JSONForms } from './JSONForms';
import { LinkButton } from '@crema/core/LinkButton';
// import { Parser } from 'json2csv';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        heading: {
            fontWeight: 500,
            color: 'black',
            lineHeight: '48px',
        },
        exportTagsButton: {
            height: 40,
            width: 150
        },
        lessonBox: {
            overflow: 'scroll',
            minWidth: '320px',
            maxWidth: '320px',
            // height: '100%',
            boxShadow: '0px 0px 2px 2px rgba(0,0,0,0.12)',
            transition: 'all 0.5s ease',
            // paddingTop: '0px',
            [theme.breakpoints.down('xs')]: {
                minWidth: '100%',
                maxWidth: '100%',
                width: '100%',
            },
        },
        fieldLabel: {
            // paddingRight: '16px',
            fontSize: '13px',
            color: 'black',
            width: '100%',
            marginBottom: '8px',
            marginTop: '10px'
        },
        boxStyle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 5,
            padding: 5
        },
        tabRoot: {
            backgroundColor: '#a9a2a533',
            '& .MuiTab-root': {
                // '#1890ff',

                '& .MuiButtonBase-root': {
                },
                width: '0.7em',
                fontSize: '0.85em',
                textTransform: 'none',
                color: 'black',
                fontFamily: theme.typography.fontFamily,
                fontWeight: 400
            },

            '& .MuiTab-labelIcon': {
                color: 'black'
            },

            '& .MuiTab-textColorInherit': {
                textColor: 'black'
            }
            ,

            '& .MuiTab-textColorPrimary': {
                textColor: 'black'
            }
            ,

            '& .MuiTab-textColorSecondary': {
                textColor: 'black'
            },
            '& svg': {
                color: theme.palette.secondary.main
            },
            '& .MuiTabs-indicator': {
                display: 'none'
            }
        },
        tabMenuItem: {
            minWidth: '30px',
            textTransform: 'none'

            // height: 0,
            // borderRadius: '8px !important',
            // '&.Mui-selected': {
            //     color: 'black !important',
            //     backgroundColor: fade(theme.palette.primary.main, 0.2),
            // },
            // '&.Mui-selected svg': {
            //   color: theme.palette.secondary.main
            // },
        }
    })
);

export default function DataSidebar() {
    const classes = useStyles();
    const mpSdk = MpSdk.Instance.mps;
    const currentSpaceId = useSelector<AppState, string>(({ home }) => home.currentSpace?.id || '');
    const spaceTags = useSelector<AppState, ShowcaseTagMap>(({ home }) => home.spaceTags);
    const spaceModels = useSelector<AppState, Map<string, any>>(({ home }) => home.spaceModels);

    const [rows, setRows] = React.useState<any[]>([]);

    const [tabValue, setTabValue] = React.useState("Data");
    // const [data, setTags] = useState<any[]>([]);
    const dispatch = useDispatch();
    let authUser = useAuthUser();
    // const { Parser } = require('json2csv');

    function getTagLabels(t: ShowcaseTag) {
        return t.labelIds?.map(id => {
            return store.getState().projects.projectDetail?.labelList?.find(label => label.id == id)
        }) || [];
    }

    useEffect(() => {
        console.log(`%c[st] rendering DataSidebar useEffect  `, 'color: orange;')
        let data = Object.values(spaceTags).filter(t => {
            let unb = (getTagLabels(t) || []).find(l => l?.name == 'Unbillable');
            return !unb;
        }).map(t => ({
            id: t.id,
            title: t.data.label, description: t.data.description,
            labels: getTagLabels(t),
            // price: '$' + (Math.random() * 1000).toFixed(0),
            hide: false
        }));
        data = data.concat(Array.from(spaceModels.values()).map(m => ({
            id: m.id,
            title: m.userData?.nameToShow, description: '',
            labels: [],
            // price: '$',
            hide: false
        })))

        setRows(data)

    }, [spaceTags, spaceModels])

    // )

    // }, [spaceTags])

    // const fields = ["sid", "label"];
    // const opts = { fields };
    // const parser = new Parser(opts);

    // let rows = [{ "sid": "FWuwKcRYoWO", "label": "vent 3", "description": "", "parsedDescription": [], "mediaSrc": "", "mediaType": "mattertag.media.none", "media": { "type": "mattertag.media.none", "src": "" }, "anchorPosition": { "x": 1.7973333538628569, "y": 2.62220926953443, "z": 0.2341256291860092 }, "anchorNormal": { "x": -0.9999887227369687, "y": -0.004604926149310918, "z": 0.001161487858514983 }, "color": { "r": 1, "g": 0, "b": 0 }, "enabled": true, "floorId": 0, "floorIndex": 0, "floorInfo": { "id": "0", "sequence": 0 }, "stemVector": { "x": -0.3299962785031997, "y": -0.0015196256292726031, "z": 0.0003832909933099444 }, "stemHeight": 0.33, "stemVisible": true }, { "sid": "87gSLmnGx4X", "label": "floor vent", "description": "", "parsedDescription": [], "mediaSrc": "", "mediaType": "mattertag.media.none", "media": { "type": "mattertag.media.none", "src": "" }, "anchorPosition": { "x": -0.5594571108299379, "y": 0.020787126549066448, "z": -1.4296695690043337 }, "anchorNormal": { "x": -0.0019156232287711123, "y": 0.9998546945780219, "z": 0.016938716537443804 }, "color": { "r": 1, "g": 0, "b": 0 }, "enabled": true, "floorId": 0, "floorIndex": 0, "floorInfo": { "id": "0", "sequence": 0 }, "stemVector": { "x": -0.0006321556654944671, "y": 0.3299520492107472, "z": 0.005589776457356456 }, "stemHeight": 0.33, "stemVisible": true }, { "sid": "l7btxyUg6qJ", "label": "knob1", "description": "", "parsedDescription": [], "mediaSrc": "", "mediaType": "mattertag.media.none", "media": { "type": "mattertag.media.none", "src": "" }, "anchorPosition": { "x": 1.6462014956180282, "y": 0.8670575367124711, "z": 3.776847138715913 }, "anchorNormal": { "x": -0.0015852592428935984, "y": -0.07092567279316545, "z": -0.9974803436118277 }, "color": { "r": 1, "g": 0, "b": 0 }, "enabled": true, "floorId": 0, "floorIndex": 0, "floorInfo": { "id": "0", "sequence": 0 }, "stemVector": { "x": -0.0005231355501548877, "y": -0.023405472021744606, "z": -0.3291685133919033 }, "stemHeight": 0.3300000000000001, "stemVisible": true }]

    // rows = rows.map(row => ({ ...row, id: row.sid }))
    // let columns: GridColDef[] = [
    //     { field: 'sid', },
    //     {
    //         field: 'label'
    //     }]

    // const uploadTagFile = useCallback(async (files) => {
    //     if (!currentSpaceId) {
    //         dispatch(fetchError("Space was not loaded"));
    //         return;
    //     }
    //     if (!authUser) {
    //         dispatch(fetchError("No user data"));
    //         return;
    //     }

    //     const file = files[0].file;
    //     let importedTags: any[] = [];
    //     let savedCustomData: any = null;
    //     if (file.type === 'application/json') {
    //         const reader = new FileReader();
    //         reader.onload = async (e: any) => {
    //             const content = e.target.result;
    //             importedTags = JSON.parse(content);
    //             if (!Array.isArray(importedTags)) {
    //                 dispatch(fetchError("This is not an object array, please select another file."));
    //                 return;
    //             }
    //             savedCustomData = await dispatch(saveSpaceCustomData(currentSpaceId, ' ', authUser?.uid, CustomDataType.JSON));
    //             console.log(savedCustomData.id)
    //             await Promise.all(importedTags.map(async (tag: any, index) => {
    //                 const savedCustomDataField: any = await dispatch(saveSpaceCustomDataField(currentSpaceId, savedCustomData.id, FieldType.JSON, tag));
    //                 importedTags[index].id = savedCustomDataField.id;
    //             }));
    //             setTags(importedTags);
    //             console.log(importedTags)
    //         };
    //         reader.readAsText(file);
    //     }
    //     else if (file.type === 'application/vnd.ms-excel') {
    //         const reader = new FileReader();
    //         reader.onload = async (e: any) => {
    //             const content = e.target.result;
    //             importedTags = await csv().fromString(content);
    //             if (!Array.isArray(importedTags)) {
    //                 dispatch(fetchError("This is not an object array, please select another file."));
    //                 return;
    //             }
    //             savedCustomData = await dispatch(saveSpaceCustomData(currentSpaceId, ' ', authUser?.uid, CustomDataType.JSON));
    //             console.log(savedCustomData.id)
    //             await Promise.all(importedTags.map(async (tag: any, index) => {
    //                 const savedCustomDataField: any = await dispatch(saveSpaceCustomDataField(currentSpaceId, savedCustomData.id, FieldType.JSON, tag));
    //                 importedTags[index].id = savedCustomDataField.id;
    //             }));
    //             setTags(importedTags);
    //             console.log(importedTags)
    //         };
    //         reader.readAsText(file);
    //     }

    // }, [currentSpaceId, authUser]);

    const downloadTagsFile = useCallback((data, filename, type) => {
        const file = new Blob([data], { type: type });
        if ((window.navigator as any).msSaveOrOpenBlob) // IE10+
            (window.navigator as any).msSaveOrOpenBlob(file, filename);
        else { // Others
            const a = document.createElement("a"),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }, []);

    const exportTags = useCallback(async () => {
        // if (mpSdk) {
        // mpSdk.Mattertag.getData()
        //     .then((tags: any) => {
        let tags = Object.values(store.getState().home.spaceTags).map(tag => {
            let t = JSON.parse(JSON.stringify(tag));

            t.id = '';
            delete t.projectId;
            delete t.tagHtml;
            delete t.taskTag;
            delete t.attachmentsUrls;

            return t;
        });

        if (!tags || tags.length == 0) { dispatch(fetchError("No tags in this space")); }
        const filename = store.getState().home.currentSpace?.name + '-' + 'tags.json';
        const tagsText = JSON.stringify(tags);
        downloadTagsFile(tagsText, filename, "application/json");
        dispatch(showMessage('Downloaded as .json - you can convert it to any format with external converters'))
        // });
        // }
        // else {
        //     dispatch(fetchError("Something went wrong"));
        // }
    }, [mpSdk]);

    function getColumnsFromData(data: any) {
        return (data && data.length > 0) ?
            Object.getOwnPropertyNames(data[0]).map(p => ({ field: p }))  //get property names from first row JSON
            : [];
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        {
            field: 'title',
            headerName: 'Title',
            width: 150,
            editable: true,
        },
        // {
        //     field: 'price',
        //     headerName: 'Price',
        //     width: 80,
        //     editable: true,
        // },
        {
            field: 'labels',
            headerName: 'Categories',
            width: 160,
            editable: true,

            renderCell: (params: GridRenderCellParams<any>) => (


                params.value[0] ?
                    <Chip label={params.value[0]?.name} variant='outlined' style={{ backgroundColor: params.value[0]?.color }} size='small' />
                    : null
                // <Box>
                //         {param.value && tagLabelList.length > 0 && <Scrollbar className={classes.scrollLabels}>
                //           {tagLabelList.map(label => (
                //             <Tooltip arrow title={label?.name || ''} placement='top' key={label?.id}>
                //               <Box
                //                 height={{ xs: 6, sm: 8 }}
                //                 width={20}
                //                 mx={1}
                //                 minWidth={20}
                //                 borderRadius={20}
                //                 key={label?.id}
                //                 bgcolor={label?.color}
                //               />
                //             </Tooltip>
                //           ))}
                //         </Scrollbar>}
                //       </Box>
            )
        },
        {
            field: 'Go To Tag',
            headerName: 'Go To Tag',
            width: 15,
            editable: false,

            renderCell: (params: GridRenderCellParams<any>) => (
                <Link variant="caption" component="button" underline="always"

                    // <Link
                    //     underline="always"
                    //     component="button"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        // if (params.id) {
                        // alert(JSON.stringify(params.value) )
                        // dispatch(onSetCurrentWorkshop(params.value))
                        // dispatch({ type: SET_IS_WORKSHOP_OPEN, payload: !isWorkshopOpen });

                        handleTagClick(params.id.toString())
                        Simulation.instance.handleModelClick(params.id.toString())

                        // alert(params.id)
                        // alert(params)

                        // }
                    }}>
                    Go
                </Link>


            ),
        },
        {
            field: 'hide',
            headerName: 'Hide',
            width: 15,
            editable: false,

            renderCell: (params: GridRenderCellParams<any>) => (
                <Checkbox checked={!!params.value?.hide}
                    onChange={() => {
                        let r = rows.find(row => row.id == params.id)
                        let i = rows.findIndex(row => row.id == params.id)
                        r && (rows[i].hide = true);
                        // alert(JSON.stringify(r));
                        // alert(JSON.stringify(rows[i]));

                        setRows(JSON.parse(JSON.stringify(rows)))
                    }} />


            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 75,
            editable: true,
        },
    ]
    return (console.log(`%c[st] rendering DataSidebar ${rows.map(row => row.hide)} `, 'color: orange;'),
        <Layout width='500px'>
            {/* <Box className={classes.boxStyle}>
                <h5 className={classes.fieldLabel}>Import tags from json file</h5>
                <FileUploader
                    acceptedFileTypes='.json, .csv'
                    alowOnlyOne={true}
                    handleFiles={uploadTagFile} />
            </Box> */}
            <Box className={classes.boxStyle}>
                <Box display='inline-flex'>
                <LinkButton
                    color='primary'
                    size='medium'
                    onClick={() => exportTags()}
                >
                    Export Tag Data
                </LinkButton>
                {/* <LinkButton
                    color='primary'
                    size='medium'
                    onClick={() => exportTags()}
                >
                    Export Tag Data
                </LinkButton>
                <LinkButton
                    color='primary'
                    size='medium'
                    onClick={() => exportTags()}
                >
                    Export Tag Data
                </LinkButton> */}
                </Box>
            </Box>
            <TabContext value={tabValue}>
                <Tabs
                    value={tabValue}
                    onChange={(e, v) => setTabValue(v)}
                    aria-label="Data tabs"
                    // className={classes.tabRoot}
                    indicatorColor='primary'
                    textColor='primary'
                // variant='fullWidth'
                >
                    <Tab
                        value="Data"
                        label="Data"
                        className={classes.tabMenuItem}
                    />

                    <Tab
                        value="CSV"
                        label="CSV Playground (Coming Soon)"
                        className={classes.tabMenuItem}
                        disabled={!isUserAdmin()}
                        component='div'
                    >
                        {/* <div><Badge color='secondary' style={{ marginTop: '16px' }} badgeContent={'Coming Soon'}>CSV</Badge></div> */}
                    </Tab>

                    {/* {<Badge color='secondary' style={{ marginTop: '16px' }} badgeContent={'Coming Soon'}>
                        <Tab
                        value="JSON"
                        label="JSON Playground"
                        className={classes.tabMenuItem}
                        disabled={!isUserAdmin()}
                    />
                    </Badge>} */}

                </Tabs>

                <TabPanel value="Data">

                    <Box className={classes.boxStyle}>
                        <h5 className={classes.fieldLabel}>Tag & 3D Data</h5>

                        <AppDataGrid
                            rows={rows.filter(row => !row.hide)}
                            // columns={getColumnsFromData(data)}
                            columns={columns}
                        // pageSize={20}
                        // rowsPerPageOptions={[20]}
                        />

                        {/* <TableSidebar mpSdk={mpSdk} tagsTableData={data} /> */}
                        {/* <Box style={{display:'inline-flex'}}>
                        <Button size='small' variant='contained' color="secondary" onClick={() => { }}>Remove Selected</Button>
                        <Button size='small' variant='outlined' color="secondary" onClick={() => { alert("No Quote Templates have been created for your organization yet.") }}>Create Quote</Button>
                        </Box> */}
                    </Box>
                </TabPanel>


                <TabPanel value="CSV">

                    <Box className={classes.boxStyle}>
                        <h5 className={classes.fieldLabel}>JSON</h5>
                        <JSONForms />
                    </Box>
                </TabPanel>
            </TabContext>
        </Layout>
    )
}